export default "__VITE_ASSET__4c0abb02__"